import { ProjectGeoDataByIri } from 'src/constants/projectGeoData';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateModelGeoDataIris =
  (prevIri: string, newIri: string) => (model: Model) => {
    const geoDataByIri = Object.entries(model.modelData.geoDataByIri).reduce<
      Record<string, ProjectGeoDataByIri>
    >((acc, [prevClassIri, prevGeoData]) => {
      // Update class IRI key if it matches
      const classIri = prevClassIri === prevIri ? newIri : prevClassIri;

      // Update attribute IRIs in geo data values
      const updatedGeoData: ProjectGeoDataByIri = {};

      Object.entries(prevGeoData).forEach(([key, geoDataValue]) => {
        if (geoDataValue) {
          updatedGeoData[key as keyof ProjectGeoDataByIri] = {
            ...geoDataValue,
            value:
              geoDataValue.isAttribute && geoDataValue.value === prevIri
                ? newIri
                : geoDataValue.value,
          };
        }
      });

      acc[classIri] = updatedGeoData;
      return acc;
    }, {});

    setDataProperty<ModelData>(model)(
      model.modelData,
      'geoDataByIri',
      geoDataByIri
    );
  };
